import { Component, DestroyRef, inject, Input, OnInit, ChangeDetectionStrategy, input } from '@angular/core';
import { Permission } from '../../../services/data/permission';
import { SettingControllerService } from '@eadsysteme/settingclient-v1';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfigService } from '../../../services/config/config.service';
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
	selector: 'ara-qr-generator',
	templateUrl: './ara-qr-generator.component.html',
	styleUrls: ['./ara-qr-generator.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [QRCodeComponent],
})
export class AraQrGeneratorComponent implements OnInit {
	private readonly settingService = inject(SettingControllerService);
	readonly configService = inject(ConfigService);

	private readonly destroyRef = inject(DestroyRef);
	private readonly PERMISSIONS_URL_SUFFIX = '/permissions?authcode=';

	readonly permission = input<Permission>(undefined);
	public readonly width = input<number>(undefined);

	@Input()
	public qrCodeValue: string;

	ngOnInit(): void {
		const permission = this.permission();
		if (permission && !this.qrCodeValue) {
			if (permission.permissionType === 'RESIDENT') {
				this.setQrCodeValue(this.configService.getAraAppUrl());
			} else {
				this.settingService
					.getConfigValue(permission.area, 'portal', 'general', 'portal_url')
					.pipe(takeUntilDestroyed(this.destroyRef))
					.subscribe({
						next: (configValues) => {
							this.setQrCodeValue(configValues?.value?.replaceAll('%3A', ':').replaceAll('%2F', '/') ?? 'test.de');
						},
					});
			}
		}
	}

	setQrCodeValue(url: string) {
		this.qrCodeValue = url + this.PERMISSIONS_URL_SUFFIX + this.permission().authCode;
	}
}
